// Data table that scrolls sideways on a phone instead of breaking the page.
import type { ReactNode } from 'react';

export type Column<Row> = {
  label: string;
  /** Right-aligned numbers. */
  numeric?: boolean;
  render: (row: Row) => ReactNode;
};

type TableProps<Row> = {
  columns: readonly Column<Row>[];
  rows: readonly Row[];
  rowKey: (row: Row) => string;
  caption?: string;
};

export function Table<Row>({ columns, rows, rowKey, caption }: TableProps<Row>) {
  return (
    <div className="table-wrap">
      <table className="table">
        {caption && <caption className="sr-only">{caption}</caption>}
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.label} className={c.numeric ? 'r' : undefined}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)}>
              {columns.map((c) => (
                <td key={c.label} className={c.numeric ? 'r' : undefined}>
                  {c.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
